import axiosInstance from "../../../helpers/api";

export const getAllGroups = (course_id) => {
  return axiosInstance.get(`/student/student-groups/${course_id}`);
};
